module.exports = __webpack_public_path__ + "img/baggage.d6f7e959.svg";